module.exports = __webpack_public_path__ + "img/Photo_1__West_Street__975_105_2.62c10f04.jpg";